import './bootstrap.js'

import { createApp } from 'vue';
import App from './App.vue';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import FocusTrap from 'primevue/focustrap';
import Tooltip from 'primevue/tooltip';
import router from './router';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import { Chart } from 'chart.js/auto';
import ptBR from './../lang/pt_BR.json';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '../css/app.css';

import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'


const app = createApp(App);

const applyChartThemeDefaults = () => {
    const isDark = document.documentElement.classList.contains('my-app-dark');
    Chart.defaults.color = isDark ? '#e5e7eb' : '#334155';
    Chart.defaults.borderColor = isDark ? '#374151' : '#e2e8f0';
    if (Chart.defaults.plugins?.colors) {
        Chart.defaults.plugins.colors.enabled = true;
        Chart.defaults.plugins.colors.forceOverride = true;
    }
};

Chart.register({
    id: 'dynamicColors',
    beforeInit(chart) {
        const isDark = document.documentElement.classList.contains('my-app-dark');
        const textColor = isDark ? '#c9d1d9' : '#475569';
        const gridColor = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';
        const legendColor = isDark ? '#9ca3af' : '#64748b';

        if (chart.config.options.scales) {
            Object.keys(chart.config.options.scales).forEach(scaleKey => {
                const scale = chart.config.options.scales[scaleKey];
                if (scale.ticks) {
                    scale.ticks.color = textColor;
                }
                if (scale.grid) {
                    const c = scale.grid.color;
                    if (!c || c === 'rgba(255,255,255,0.06)' || c === 'rgba(255,255,255,0.08)' || c === 'transparent') {
                        scale.grid.color = c === 'transparent' ? 'transparent' : gridColor;
                    }
                }
            });
        }

        if (chart.config.options.plugins?.legend?.labels) {
            chart.config.options.plugins.legend.labels.color = legendColor;
        }
    }
});

applyChartThemeDefaults();
window.addEventListener('theme-changed', applyChartThemeDefaults);

app.use(router);
app.use(ToastService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);
app.directive('focustrap', FocusTrap);
app.use(PrimeVue,{
    locale: ptBR,
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.my-app-dark',
        }
    }
});

app.mount('#app');